<template>
  <RevDrawer :name :title="i18n(translations.header)">
    <template #body>
      <h2 class="heading-1 mb-24">
        {{ i18n(translations.title) }}
      </h2>

      <RevIllustration
        :alt="i18n(translations.illustrationAlt)"
        class="rounded-md mb-24 w-full object-cover"
        :height="600"
        :src="illustrationSrc"
        :width="800"
      />

      <h3 class="heading-3 mb-12">
        {{ i18n(translations.section1Subtitle) }}
      </h3>
      <p class="body-1 mb-32">
        {{ i18n(translations.section1Body) }}
      </p>

      <h3 class="heading-3 mb-16">
        {{ i18n(translations.section2Subtitle) }}
      </h3>

      <ul class="bg-static-info-mid rounded-lg flex flex-col gap-16 p-24">
        <li
          v-for="stat in stats"
          :key="stat.number.id"
          class="flex items-baseline gap-16"
        >
          <span class="punchline-sans w-72 shrink-0 text-right">
            {{ i18n(stat.number) }}
          </span>
          <span class="body-1">
            {{ i18n(stat.text) }}
          </span>
        </li>
      </ul>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './BatteryStandardsDrawer.translations'

defineProps<{
  name: string
  illustrationSrc: string
}>()

const i18n = useI18n()

const stats = [
  { number: translations.stat1Number, text: translations.stat1Text },
  { number: translations.stat2Number, text: translations.stat2Text },
  { number: translations.stat3Number, text: translations.stat3Text },
] as const
</script>
